import * as Yup from "yup";

export default function isValidUrl(url: string): boolean {
  return Yup.string().url().required().isValidSync(url);
}
